import { authAddress } from './AuthStore';

export const updateAuthAddress = (value) => authAddress.update((oldValue) => value);
``